import axios from '@/libs/api.request'

export const getstallinfo = (page, limit, key, value) => {
    return axios.request({
        url: '/v1/stall/cripple/',
        method: 'get',
        params: {
            page,
            limit,
            key,
            value
        }
    })
}

export const updatestall = (data) => {
    return axios.request({
        url: '/v1/stall/cripple/',
        method: 'post',
        data
    })
}
